import { createRouter, createWebHistory } from 'vue-router';

import routes from './routes';
import useAuthGuard from './authGuard';

const router = createRouter({
  history: createWebHistory(),
  routes,
});

useAuthGuard(router);

export default router;
